import { Button, Form, InputGroup } from "react-bootstrap";
import { useState } from "react";
import { ChartOfAccountSelector } from "../utils/ExpensesSelector";
import MagnifyIcon from "mdi-react/MagnifyIcon";
import { Popover } from "react-tiny-popover";
import AddAccounts from "../modals/AddAccounts";

function SubAccountPicker({ formik, label = "Sub Account" }) {
  const [showJournalPopover, setShowJournalPopover] = useState(false);
  const [showCreateNewAccountModal, setShowCreateNewAccountModal] = useState(
    false
  );

  const handleSelectedAccount = account => {
    formik.setFieldValue("subAccountID", account.AccountID);
    formik.setFieldValue("subAccountDescription", account.Description);
    formik.setFieldValue("subAccountType", account.Type);
    setShowJournalPopover(false);
  };

  const handleAccountCreated = newAccount => {
    // Invalidate and refetch accounts query
    handleSelectedAccount(newAccount);
    setShowCreateNewAccountModal(false);
  };

  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label>{label}</Form.Label>
        <div className="d-flex gap-3">
          <InputGroup hasValidation>
            <Form.Control
              placeholder="Select Account"
              value={`${formik.values?.subAccountID || "..."} / ${formik.values
                ?.subAccountDescription || "..."} / ${formik.values
                ?.subAccountType || "..."}`}
              onChange={() => {}}
              readOnly
              isInvalid={
                formik.touched.subAccountID && !!formik.errors.subAccountID
              }
            />

            <Popover
              isOpen={showJournalPopover}
              onClickOutside={() => setShowJournalPopover(false)}
              content={() => (
                <ChartOfAccountSelector
                  handleSelectedExpense={handleSelectedAccount}
                  usage={"chart of accounts"}
                  Type={formik?.values?.Type}
                />
              )}
              position="bottom"
            >
              <InputGroup.Text onClick={() => setShowJournalPopover(true)}>
                <MagnifyIcon />
              </InputGroup.Text>
            </Popover>
          </InputGroup>
          <Button
            size="sm"
            variant="outline-primary"
            onClick={() => setShowCreateNewAccountModal(true)}
            className="text-nowrap"
          >
            + Create New
          </Button>
        </div>
      </Form.Group>

      {showCreateNewAccountModal && (
        <AddAccounts
          show={showCreateNewAccountModal}
          onHide={() => setShowCreateNewAccountModal(false)}
          accountCreated={handleAccountCreated}
          disableSubAccountAddition={true}
        />
      )}
    </>
  );
}

export default SubAccountPicker;
